import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-login-layout',
  templateUrl: './login-layout.component.html',
  styleUrls: ['./login-layout.component.css']
})
export class LoginLayoutComponent implements OnInit {

  constructor() { 
    console.log('login-layout.component - constructor');
  }

  ngOnInit() {
    console.log('login-layout.component - ngOnInit');
  }

}
